<template>
  <section class="app-main">
    <transition name="fade" mode="out-in">
      <router-view :key="key"></router-view>
    </transition>
  </section>
</template>

<script>
export default {
  name: 'AppMain',
  computed: {
    key() {
      return this.$route.name !== undefined ? this.$route.name : this.$route
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/layout/AppMain.vue?1f32949a